var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalLycaFr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.0004 45.6216C62.9725 44.3769 62.6661 43.1528 62.1022 42.0334C61.5383 40.9141 60.7304 39.926 59.7339 39.1372C58.7021 38.4009 57.5163 37.8913 56.2595 37.6442C55.0028 37.397 53.7053 37.4182 52.4579 37.7062C52.2879 37.7473 51.9356 37.8387 51.8492 37.7062C51.7835 37.5148 51.7835 37.308 51.8492 37.1166C52.7197 33.2013 51.2393 29.8743 47.7096 27.9743C46.4404 27.2769 45.004 26.9138 43.5441 26.9213C42.0842 26.9287 40.6519 27.3064 39.3904 28.0167C38.1593 28.6614 37.1252 29.6075 36.3917 30.7602C35.6581 31.9129 35.2509 33.2318 35.2109 34.5846L35.2534 53.8655H54.4222C55.5523 53.896 56.6762 53.694 57.7196 53.2731C58.7629 52.8521 59.7018 52.2217 60.4741 51.4236C62.0673 49.8824 62.9739 47.8001 63.0004 45.6216Z",
    fill: "#08DC7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3385 33.658C33.3396 34.3096 32.5141 35.1927 31.9326 36.2315C31.3512 37.2704 31.0312 38.4342 31 39.6231V58.079H49.4336C50.6324 58.0254 51.8011 57.6876 52.8425 57.0937C53.8839 56.4997 54.7679 55.6667 55.4211 54.6639H34.4245V33.658H34.3385Z",
    fill: "#006AE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalLycaFr);
export default __webpack_public_path__ + "static/media/logoModalLycaFR.eabe2dd9c12621a2940c07a7b978cd13.svg";
export { ForwardRef as ReactComponent };